import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-bg p-8 text-fg">
      <div className="text-center">
        <h1 className="display text-display-lg">Not found</h1>
        <p className="mt-2 text-sm text-fg-3">No route matches the URL.</p>
        <Link
          to="/"
          className="mt-4 inline-block text-sm text-fg-2 underline-offset-2 hover:underline"
        >
          Back home
        </Link>
      </div>
    </main>
  );
}
